import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15.809,
	height: 15.809,
	viewBox: "0 0 15.809 15.809",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "download_FILL0_wght300_GRAD0_opsz24",
		d: "M187.905-768.1l-4.5-4.5,1.111-1.143,2.6,2.6V-780H188.7v8.853l2.6-2.6L192.4-772.6Zm-6,3.912a1.839,1.839,0,0,1-1.352-.553A1.839,1.839,0,0,1,180-766.1v-2.858h1.581v2.858a.31.31,0,0,0,.1.223.31.31,0,0,0,.223.1h12a.31.31,0,0,0,.223-.1.31.31,0,0,0,.1-.223v-2.858h1.581v2.858a1.839,1.839,0,0,1-.553,1.352,1.839,1.839,0,0,1-1.352.553Z",
		transform: "translate(-180.001 779.999)"
	})
});
export default SvgDownload;
